import React, { useState } from "react";
import { Button, Grid, Typography } from "@material-ui/core";
import { MainTemplate } from "shared/MainTemplate/MainTemplate";
import { settingsServices } from "api/services";
import { useEffect } from "react";
import Loader from "shared/Loader/Loader";
import Form from "shared/Form/Form";
import "./SettingsPage.sass";
import { useRef } from "react";
import { fields, view } from "./formData/formData";
import { UserRoles } from "api/services/user/types";
import { useSelector } from "react-redux";
import { AppState } from "store/store";
import handleNotification from "helpers/handleNotification";

export const SettingsPage: React.FC = () => {
	const { user } = useSelector((state: AppState) => state.userReducer);
	const { currentLang } = useSelector((state: AppState) => state.langReducer);
	const [loading, setLoading] = useState(false);
	const [data, setData] = useState<IAnyObject>();
	const formRef = useRef<any>();

	useEffect(() => {
		if (currentLang?.code) getSettings();
	}, [currentLang?.code]);

	const getSettings = async () => {
		const res = await settingsServices
			.getSettings()
			.then((res) => res.data.data);
		setData(res);
	};

	const updateSettings = async () => {
		const formRes = formRef?.current.submit();
		if (formRes && formRes.hasErrors && user?.role !== "SU") {
			handleNotification("Заполните поля");
			return;
		}

		setLoading(true);
		try {
			await settingsServices.updateSettings(formRes.res);
			handleNotification("Успешно сохранено", "success");
			getSettings();
		} finally {
			setLoading(false);
		}
	};

	return (
		<MainTemplate title='Настройки' hideBtn>
			<div className='settings-page'>
				<Grid container className='settings-page__general'>
					<Grid container>
						{data && (
							<Form
								ref={formRef}
								initialData={data}
								view={view}
								fields={fields}
							/>
						)}
					</Grid>
					<Button
						color='primary'
						className='settings-page__button'
						variant='contained'
						onClick={updateSettings}
					>
						<Loader loading={loading}>Сохранить</Loader>
					</Button>
				</Grid>
			</div>
		</MainTemplate>
	);
};
